export default __webpack_public_path__ + "static/media/elevated_occupancy.fb7d7958.png";